import React from 'react';

import { showModal } from 'modal.react.js';
import { useSelector } from 'react-redux';

import FormSection from 'components/Layouts/Form/FormSection';
import { Alert } from 'components/shared/Alert';
import Button from 'components/shared/Button';
import Divider from 'components/shared/Divider';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import area from 'components/shared/GlobalModalArea/area';
import StickyFooter from 'components/shared/StickyFooter/StickyFooter';
import Text from 'components/shared/Typography/Text';
import { pageDataSelector } from 'store/page/selectors';

import { BuilderFooterButton } from '../../shared/BuilderFooterButton';
import PageButtonsWrapper from '../../shared/PageButtons';
import { useEditedRoom } from './functions';
import s from './index.module.css';
import { RoomFormModal } from './RoomFormModal';
import { RoomList } from './RoomList';

function Rooms() {
  const page = useSelector(pageDataSelector);
  const rooms = page.rooms;

  const roomManager = useEditedRoom();

  const onAddNewRoom = () => {
    showModal(area, (res) => {
      return (
        <RoomFormModal
          page={page}
          onSubmit={(value) => {
            roomManager.handleAddNewRoom(value);
            res();
          }}
        />
      );
    });
  };

  const onEditRoom = (index: number) => {
    showModal(area, (res) => {
      return (
        <RoomFormModal
          room={rooms[index]}
          page={page}
          onSubmit={(value) => {
            roomManager.handleEditRoom(index, value);
            res();
          }}
        />
      );
    });
  };

  return (
    <FormSection className={s.section}>
      <Alert
        variant="info"
        content="You can skip this tab altogether or only fill in the room type that is relevant to your booking."
        className={s.alert}
      />

      <div className={s.texts}>
        <Text type="brandon" size="default" isStrong>
          Rooms
        </Text>
        <Text type="brandon" size="regular" color="gray-600">
          Add rooms for this property by rate category. These should be the room types that can be confirmed on booking.
        </Text>
      </div>

      <Divider />

      <RoomList
        isDisabled={roomManager.isPendingRequest}
        rooms={rooms}
        handleEditRoom={onEditRoom}
        handleDeleteRoom={roomManager.handleDeleteRoom}
      />

      <div className={s.btns}>
        <Button onClick={onAddNewRoom} disabled={roomManager.isPendingRequest}>
          Add New Room
        </Button>
      </div>

      <StickyFooter wrapperClassName={s.stickyFooter}>
        <FormActions isRight>
          <BuilderFooterButton
            disabled={roomManager.isPendingRequest}
            onClick={roomManager.handleNext}
            id="RoomsNextButton"
          >
            Next
          </BuilderFooterButton>
        </FormActions>

        <PageButtonsWrapper
          hasValidationErrors={roomManager.isPendingRequest}
          isPublishDisabled
          onSave={roomManager.handleSave}
        />
      </StickyFooter>
    </FormSection>
  );
}

export default Rooms;
